import { URL_GET_SESSION_SUMMARY } from 'services/urls.js';
import API from 'services/api.js';
import { actionSetMessage } from 'components/messages/actions.js';
import { AppDispatch } from 'index';

const SET_SESSION_SUMMARY = 'SET_SESSION_SUMMARY';
const RESET_SESSION_SUMMARY = 'RESET_SESSION_SUMMARY';

export type SummaryInfo = {
	SessionID: number;
	Client: number | null;
	TradingName: string | null;
	SessionName: string | null;
	Head: number | null;
	Age: string | null;
	BreedType: string | null;
	sessionStartUtc: Date;
	sessionEndUtc: Date | null;
	timezone: string | null;
	displayUnits: 'm' | 'i';
	adjustType?: number | null;
	adjustFactor?: number | null;
	adjustName?: string | null;
	LatestRecord?: Date;
	methane?: number;
};
export type WeigherInfo = {
	WeigherID: number;
	Species: string;
	Name: string;
	SerialNumber: number;
	WeigherLink?: string;
	status: {
		Battery: number;
		Comms: number;
		Location: { lat: number; lon: number };
		LoadBars: number;
		WeigherLink?: string;
	};
};
export type ADGStats = {
	ADG: number | null;
	days: number | null;
	animalCount: number;
};
export type WeightStats = {
	RecCount: number;
	AnimCount: number;
	Avg: number | null;
	Min: number | null;
	Max: number | null;
};
export type SessionSummaryData = {
	summ: SummaryInfo;
	weighers: WeigherInfo[];
	adg1: ADGStats;
	adg2: ADGStats;
	adg3: ADGStats;
	adg4: ADGStats;
	adgAll: ADGStats;
	dataAllDay: WeightStats;
	data10Day: WeightStats;
	data5Day: WeightStats;
	data1Day: WeightStats;
	lastRecordUtc: Date;
};

export const actionSetSessionSummaryData = (
	data: SessionSummaryData | null
) => {
	return {
		type: SET_SESSION_SUMMARY,
		data,
	};
};

export const actionFetchSummaryData = (
	sessionId: number,
	setLoading: (l: boolean) => void
) => {
	return (dispatch: AppDispatch) => {
		const params = {
			params: {
				sessionId: sessionId,
			},
		};
		return API.get(URL_GET_SESSION_SUMMARY, params)
			.then((response) => {
				console.log('actionFetchSummaryData(): response.data', response.data);
				if (response.data.length === 0) {
					// empty set
					dispatch(actionSetSessionSummaryData(null));
				} else {
					dispatch(actionSetSessionSummaryData(response.data[0]));
				}
			})
			.catch((error) => {
				dispatch(actionSetMessage('Err getting summary data: ' + error));
			})
			.then(() => {
				setLoading(false);
			});
	};
};

export const actionResetSessionSummaryData = () => {
	return { type: RESET_SESSION_SUMMARY };
};

export function sessionSummary(
	state: SessionSummaryData | null = null,
	action: { type?: string; data?: SessionSummaryData | null }
) {
	switch (action.type) {
		case SET_SESSION_SUMMARY:
			return action.data;
		case RESET_SESSION_SUMMARY:
			return null;
		default:
			return state;
	}
}
